<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <v-card style="position: relative">
      <v-overlay
        absolute
        :value="submitting"
        class="text-center"
      >
        <v-progress-circular
          indeterminate
          :size="50"
          color="primary"
        />
        <p class="text-overline white--text mt-4">
          Propagating changes. May take a while...
        </p>
      </v-overlay>
      <v-card-title class="text-h5">
        Docketwise Remove Contact
      </v-card-title>
      <v-card-text>
        <p>
          Would you like to remove the docketwise contact info for <b>({{ title }})</b>?
        </p>
        <v-checkbox
          v-model="deleteFromDocketwise"
        >
          <template #label>
            <span>Also <b>DELETE</b> contact from docketwise</span>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="_ => onSubmit(deleteFromDocketwise)"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PEPartyDocketwiseRemoveDialog',

  props: {
    onSubmit: {
      type: Function,
      required: true,
    },

    submitting: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      deleteFromDocketwise: false,
    }
  },

  computed: {
    dialog: {
      get () { return this.value },
      set (val) { this.$emit('input', val) },
    },
  },

}
</script>
